export const SIDE_NAV_WIDTH = 280;
/** Space above and below the page content: margin + padding top, padding bottom. */
export const LAYOUT_BORDER_OFFSET = 64;
export const LAYOUT_VERTICAL_CHROME = 3 * LAYOUT_BORDER_OFFSET;
